/**
 * Kakao OAuth 관련 핸들러 함수들
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
/**
 * 카카오 Authorization Code 교환 함수
 */ export var createKakaoAuthCodeExchange = function(config) {
    return /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(authCode) {
            var tokenEndpoint, params, response, tokenData, access_token, refresh_token, id_token, expires_in, storedUser, user, error, error1, _error_response_data, _error_response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log('[OAuth] Exchanging Kakao authorization code');
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        tokenEndpoint = (import.meta.env.VITE_AUTH_SERVER_URL || 'https://auth.ugot.uk') + '/oauth2/token';
                        params = new URLSearchParams({
                            grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
                            client_id: 'app-client',
                            subject_token: authCode,
                            subject_token_type: 'urn:x-oauth:params:token-type:authorization-code',
                            actor_token: 'kakao',
                            scope: 'openid profile email api.read'
                        });
                        return [
                            4,
                            axios.post(tokenEndpoint, params, {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    'Accept': 'application/json'
                                },
                                withCredentials: true,
                                maxRedirects: 0,
                                validateStatus: function(status) {
                                    return status >= 200 && status < 400;
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        // 응답이 배열 형태인 경우 처리
                        tokenData = response.data;
                        if (Array.isArray(response.data) && response.data.length === 2 && response.data[0] === 'java.util.LinkedHashMap') {
                            tokenData = response.data[1];
                        }
                        if (!(tokenData && tokenData.access_token)) return [
                            3,
                            8
                        ];
                        access_token = tokenData.access_token, refresh_token = tokenData.refresh_token, id_token = tokenData.id_token, expires_in = tokenData.expires_in;
                        // 토큰 저장
                        config.tokenManager.setToken(access_token);
                        config.apiService.setToken(access_token);
                        if (!config.isVSCodeEnv) {
                            localStorage.setItem(TOKEN_KEY, access_token);
                            if (refresh_token) {
                                localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
                            }
                            if (id_token) {
                                localStorage.setItem(ID_TOKEN_KEY, id_token);
                            }
                        }
                        // 사용자 프로필 가져오기
                        return [
                            4,
                            config.fetchUserProfile(access_token)
                        ];
                    case 3:
                        _state.sent();
                        if (!(config.setAuthenticatedState && !config.isVSCodeEnv)) return [
                            3,
                            7
                        ];
                        storedUser = localStorage.getItem('edusense_auth_user');
                        if (!storedUser) return [
                            3,
                            7
                        ];
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        user = JSON.parse(storedUser);
                        console.log('[OAuth] Kakao Auth Code - setAuthenticatedState 호출 with ID token:', !!id_token);
                        return [
                            4,
                            config.setAuthenticatedState(user, access_token, refresh_token, expires_in, 'Bearer', id_token // ID 토큰을 포함하여 전달
                            )
                        ];
                    case 5:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.error('[OAuth] Kakao Auth Code - setAuthenticatedState 호출 실패:', error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2,
                            {
                                success: true,
                                data: {
                                    access_token: access_token,
                                    refresh_token: refresh_token,
                                    id_token: id_token,
                                    expires_in: expires_in
                                }
                            }
                        ];
                    case 8:
                        console.error('[OAuth] Token exchange response missing access_token:', response.data);
                        return [
                            2,
                            {
                                success: false,
                                message: (tokenData === null || tokenData === void 0 ? void 0 : tokenData.error_description) || (tokenData === null || tokenData === void 0 ? void 0 : tokenData.error) || '토큰 교환에 실패했습니다.'
                            }
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error1 = _state.sent();
                        console.error('[OAuth] Kakao auth code exchange failed:', error1);
                        return [
                            2,
                            {
                                success: false,
                                message: ((_error_response = error1.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.error_description) || error1.message || '카카오 로그인 중 오류가 발생했습니다.'
                            }
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function(authCode) {
            return _ref.apply(this, arguments);
        };
    }();
};
